import React from 'react';
import CenteredModal from 'components/UI/Modal/CenteredModal';
import Button from 'components/UI/V3/Button/Button';
import { formatNumber } from '../utils';
import styles from './SendConfirmModal.module.scss';

interface SendConfirmModalProps {
    name: string;
    // null when the count isn't known before sending (API source).
    recipients: number | null;
    locations: number;
    duplicates: number;
    sending?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

export const SendConfirmModal: React.FC<SendConfirmModalProps> = ({
    name,
    recipients,
    locations,
    duplicates,
    sending,
    onCancel,
    onConfirm
}) => (
    <CenteredModal
        isOpen
        onClose={onCancel}
        maxWidth="small"
        className={styles.modal}
    >
        <CenteredModal.Header title={`Send “${name}”?`} />
        <CenteredModal.Content padding="large">
            <div className={styles.content}>
                {recipients === null ? (
                    <p>
                        Each of the{' '}
                        <strong>
                            {locations} location{locations === 1 ? '' : 's'}
                        </strong>{' '}
                        will send this email to its customers now.
                    </p>
                ) : (
                    <p>
                        <strong>{formatNumber(recipients)} customers</strong> across{' '}
                        <strong>
                            {locations} location{locations === 1 ? '' : 's'}
                        </strong>{' '}
                        will receive this email now.
                    </p>
                )}
                {duplicates > 0 && (
                    <p className={styles.note}>
                        {formatNumber(duplicates)} customers shop at more than one location — they get it only once.
                    </p>
                )}
                <div className={styles.actions}>
                    <Button
                        variant="outlined"
                        label="Cancel"
                        onClick={onCancel}
                    />
                    <Button
                        variant="black"
                        label={sending ? 'Sending…' : 'Send now'}
                        disabled={sending}
                        onClick={onConfirm}
                    />
                </div>
            </div>
        </CenteredModal.Content>
    </CenteredModal>
);

export default SendConfirmModal;
